<template>
<v-row>
    <v-col>
        <m-edit-date
            label="Start Date"
            :value="value == null ? '2020-01-01' : value.start"
            v-on:input="onSetStartDate($event)"
        />
    </v-col>
    <v-col>
        <m-edit-date
            label="Stop Date"
            :value="value == null ? '2020-01-31' : value.stop"
            v-on:input="onSetStopDate($event)"
        />
    </v-col>

    <v-col
        class="flex-grow-0"
    >

    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                style="margin-top: 10px"
                v-bind="attrs"
                v-on="on"
                v-on:click="prevMonth()"
            >
                <v-icon>
                    mdi-chevron-left
                </v-icon>
            </v-btn>
        </template>
        <span>Previous Month</span>
    </v-tooltip>

        
    </v-col>
    <v-col
        class="flex-grow-0"
    >
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                style="margin-top: 10px"
                v-bind="attrs"
                v-on="on"
                v-on:click="currentMonth()"
            >
                <v-icon>
                    mdi-crosshairs-gps
                </v-icon>
            </v-btn>
        </template>
        <span>Current Month</span>
    </v-tooltip>
    </v-col>
    <v-col
        class="flex-grow-0"
    >
        <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                style="margin-top: 10px"
                v-bind="attrs"
                v-on="on"
                v-on:click="nextMonth()"
            >
                <v-icon>
                    mdi-chevron-right
                </v-icon>
            </v-btn>
        </template>
        <span>Next Month</span>
    </v-tooltip>
    </v-col>

    <v-col
        class="flex-grow-0"
        v-if="menu_items.length > 0"
    >
        <m-edit-menu
            :menu_items="menu_items"
            v-on:menu-action="onMenuAction($event)"
            as_btn
            style="margin-top: 10px"
         />

    </v-col>
    

</v-row>
</template>

<script>
export default {

    props: {

        value: {
            type: Object,
            default: function() { return { 'start' : '2020-01-01', 'stop' : '2020-01-31' }; }
        },

        menu_items: {
            type: Array,
            default: function() { return []; }
        },
    },

    mounted () {
        if ( this.value == null )
        {
            this.currentMonth();
        }
    },

    methods: {

        onSetStartDate(new_date) 
        {
            this.$emit('input', { 'start' : new_date, 'stop' : this.value.stop } );
        },

        onSetStopDate(new_date) 
        {
            this.$emit('input', { 'start' : this.value.start, 'stop' : new_date } );
        },

        currentMonth()
        {
            var date = new Date();

            let start_date = new Date(date.getFullYear(), date.getMonth(), 1).toISOString().substring(0,10);
            let stop_date = new Date(date.getFullYear(), date.getMonth() + 1, 0).toISOString().substring(0,10);

            this.$emit('input', { 'start' : start_date, 'stop' : stop_date } );
        },

        nextMonth()
        {
            var date = this.startDateAsDateObject();

            let start_date = new Date(date.getFullYear(), date.getMonth()+1, 1).toISOString().substring(0,10);
            let stop_date = new Date(date.getFullYear(), date.getMonth() + 2, 0).toISOString().substring(0,10);
            
            this.$emit('input', { 'start' : start_date, 'stop' : stop_date } );
        },

        prevMonth()
        {
            var date = this.startDateAsDateObject();

            let start_date = new Date(date.getFullYear(), date.getMonth()-1, 1).toISOString().substring(0,10);
            let stop_date = new Date(date.getFullYear(), date.getMonth(), 0).toISOString().substring(0,10);
            
            this.$emit('input', { 'start' : start_date, 'stop' : stop_date } );
        },

        startDateAsDateObject()
        {
            let split = this.value.start.split('-');

            let full_year = parseInt(split[0]);
            let month = parseInt(split[1]-1);
            let day = parseInt(split[2]);

            return new Date(full_year, month, day, 0, 0, 0);
        },

        onMenuAction(menu_item)
        {
            this.$emit(menu_item.event, menu_item);
        },
    },
        
}
</script>

<style lang="scss" scoped>

</style>